import {SUCCUBES_SEDUCTION_SUCCESS_THRESHOLD} from "../../../configs/factions/succubes";

/**
 * Итог попытки соблазнения: бросок d20 плюс разница численности (соблазнитель
 * минус цель) должен быть не меньше порога успеха
 * @param {number} roll - результат броска d20 (1-20)
 * @param {number} attackerSize - численность отряда суккубов
 * @param {number} targetSize - численность отряда цели
 * @returns {boolean} успешна ли попытка
 */
export const calculateSeductionSuccess = (roll, attackerSize, targetSize) => {
  return (roll + attackerSize - targetSize) >= SUCCUBES_SEDUCTION_SUCCESS_THRESHOLD;
};
